module.exports = __webpack_public_path__ + "img/play-icon.c94580f6.svg";